<template>
  <b-container class="invadobays">
    <b-row v-if="invadobay_section.title || invadobay_section.description">
      <b-col>
        <div
          v-if="invadobay_section.title"
          class="invadobays__info h3 semibold m-0"
        >
          {{ invadobay_section.title }}
        </div>
        <p
          v-if="invadobay_section.description"
          class="text-muted m-0 invadobays__info"
        >
          {{ invadobay_section.description }}
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-for="(elem, i) in sliced_previews"
        :key="`invadobay:${invadobay_section.preview_type}:${i}:${elem.id}`"
        :class="`${
          invadobay_section.preview_type === 'card' ? 'p-0' : ''
        } pb-4`"
        :lg="preview_columns_lg(invadobay_section.preview_type, i)"
        :md="preview_columns_md(invadobay_section.preview_type)"
        :sm="12"
      >
        <invadobay-search-preview
          v-if="invadobay_section.preview_type === 'search'"
          :elem="elem"
          :wide="is_single_invadobay"
        />
        <invadobay-card-preview
          v-else-if="invadobay_section.preview_type === 'card'"
          :elem="elem"
        />
        <invadobay-compact-preview v-else :elem="elem" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import InvadobayCardPreview from "./invadobay-card-preview.vue";
import InvadobayCompactPreview from "./invadobay-compact-preview.vue";
import InvadobaySearchPreview from "./invadobay-search-preview.vue";

export default {
  name: "invadobay-previews",
  components: {
    "invadobay-search-preview": InvadobaySearchPreview,
    "invadobay-compact-preview": InvadobayCompactPreview,
    "invadobay-card-preview": InvadobayCardPreview,
  },
  props: {
    invadobay_section: Object,
  },
  methods: {
    is_full_width_search(i) {
      const { invadobays = [] } = this.invadobay_section || {};
      return invadobays.length % 2 !== 0 && invadobays.length === i + 1;
    },
    preview_columns_lg(type, i) {
      if (type === "search") {
        return this.is_full_width_search(i) ? 12 : 6;
      }
      if (type === "card") {
        return 4;
      }
      if (type === "compact") {
        return 3;
      }
      return 12;
    },
    preview_columns_md(type) {
      if (type === "compact") {
        return 6;
      }
      if (type === "card") {
        return 12;
      }
      return 12;
    },
  },
  computed: {
    // The property+rooms slider is only used when the section has a single
    // invadobay; other odd counts still get a full-width last column, but with
    // the standard search preview.
    is_single_invadobay() {
      return (this.invadobay_section.invadobays || []).length === 1;
    },
    sliced_previews() {
      if (this.invadobay_section.preview_type === "card") {
        return this.invadobay_section.invadobays.slice(0, 3);
      }
      if (this.invadobay_section.preview_type === "compact") {
        return this.invadobay_section.invadobays.slice(0, 4);
      }
      return this.invadobay_section.invadobays;
    },
  },
};
</script>

<style lang="scss" scoped>
.invadobays {
  position: relative;
  z-index: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  &__info {
    padding: 0px 0.5rem;
  }
}
</style>
